import React, { useState } from 'react';
import './FeedbackWidget.css';

const FeedbackWidget = ({ onSubmit, disabled = false }) => {
  const [selectedRating, setSelectedRating] = useState(null); // 'positive' or 'negative'
  const [showTextArea, setShowTextArea] = useState(false);
  const [textFeedback, setTextFeedback] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(false); // Track if feedback has been submitted

  const handleRatingClick = (rating) => {
    if (disabled || isSubmitting || hasSubmitted) return;
    
    const newRating = selectedRating === rating ? null : rating;
    setSelectedRating(newRating);
    
    if (newRating) {
      setShowTextArea(true);
    } else {
      setShowTextArea(false);
      setTextFeedback('');
    }
  };

  const handleSubmit = async () => {
    if (!selectedRating || disabled || isSubmitting || hasSubmitted) return;
    
    setIsSubmitting(true);
    try {
      await onSubmit(selectedRating === 'positive', textFeedback);
      // Mark as submitted and disable after successful submission
      setHasSubmitted(true);
      setShowTextArea(false);
      setTextFeedback('');
    } catch (error) {
      console.error('Error submitting feedback:', error);
      alert('Failed to submit feedback. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    if (hasSubmitted) return;
    setSelectedRating(null);
    setShowTextArea(false);
    setTextFeedback('');
  };

  return (
    <div className="feedback-widget">
      <div className="feedback-buttons-container">
        <div className="feedback-buttons">
          <button
            type="button"
            className={`feedback-btn thumbs-up ${selectedRating === 'positive' ? 'active' : ''} ${hasSubmitted ? 'submitted' : ''}`}
            onClick={() => handleRatingClick('positive')}
            disabled={disabled || isSubmitting || hasSubmitted}
            title={hasSubmitted ? 'Feedback submitted' : 'Thumbs up'}
          >
            👍
          </button>
          <button
            type="button"
            className={`feedback-btn thumbs-down ${selectedRating === 'negative' ? 'active' : ''} ${hasSubmitted ? 'submitted' : ''}`}
            onClick={() => handleRatingClick('negative')}
            disabled={disabled || isSubmitting || hasSubmitted}
            title={hasSubmitted ? 'Feedback submitted' : 'Thumbs down'}
          >
            👎
          </button>
          {hasSubmitted && <span className="feedback-submitted-indicator">✓</span>}
        </div>
        
        {showTextArea && selectedRating && !hasSubmitted && (
          <div className="feedback-popup-box">
            <div className="feedback-popup-header">
              <span>Add Feedback</span>
              <button 
                type="button"
                className="feedback-close-btn"
                onClick={handleCancel}
                aria-label="Close"
              >
                ×
              </button>
            </div>
            <textarea
              value={textFeedback}
              onChange={(e) => setTextFeedback(e.target.value)}
              placeholder="Optional: Add your feedback here..."
              rows={4}
              disabled={disabled || isSubmitting}
              className="feedback-text-input"
            />
            <div className="feedback-actions">
              <button
                type="button"
                className="btn btn-secondary btn-sm"
                onClick={handleCancel}
                disabled={disabled || isSubmitting}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={handleSubmit}
                disabled={disabled || isSubmitting}
              >
                {isSubmitting ? 'Submitting...' : 'Submit Feedback'}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FeedbackWidget;

